export const VERSION_RE = /^([1-9]\d?)(?:\.([1-9]\d?))?(?:\.([1-9]\d?))?$/;

export function compareVersions(a: string, b: string): number {
  const pa = a.split('.').map(Number);
  const pb = b.split('.').map(Number);
  const len = Math.max(pa.length, pb.length);
  for (let i = 0; i < len; i++) {
    const av = pa[i] ?? 0;
    const bv = pb[i] ?? 0;
    if (av !== bv) return av < bv ? -1 : 1;
  }
  return 0;
}

export function normalizeVersion(input: string): string {
  const parts = input
    .replace(/,/g, '.')
    .replace(/[^\d.]/g, '')
    .split('.')
    .filter(Boolean)
    .slice(0, 3)
    .map((p) => {
      const n = Math.max(1, Math.min(99, Number(p.replace(/^0+/, '') || '0')));
      return String(n);
    });
  return parts.length ? parts.join('.') : '1';
}
